var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Avatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 18.5,
    cy: 18.5,
    r: 18.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 18.5,
    cy: 18.5,
    r: 18.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-8---Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.3--Data-Processing---dp-yes---library-yes",
    transform: "translate(-876.000000, -431.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(575.000000, 431.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar",
    transform: "translate(301.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Photo",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Photo",
    fillOpacity: 0.3,
    fill: "#7450C8",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    mask: "url(#mask-4)",
    fill: "#7450C8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.100000, 12.950000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03585056,8.49198453 L3.114914,5.43983746 C2.68227925,4.91195261 2.00297825,4.68201349 1.35629957,4.84455755 C0.709620897,5.0071016 0.204708199,5.53469533 0.0491518472,6.21042326 C-0.106404505,6.88615119 0.113649623,7.59596686 0.618840932,8.04803587 L4.77896271,12.4135311 C5.11304497,12.7597861 5.56530895,12.9528117 6.03585056,12.949969 C6.50026156,12.9479257 6.94530516,12.7552683 7.27503577,12.4135311 L16.1263587,3.16460055 C16.4614922,2.81727251 16.65,2.34447483 16.65,1.85125242 C16.65,1.35803001 16.4614922,0.885232335 16.1263587,0.537904288 C15.4358892,-0.179301429 14.3207551,-0.179301429 13.6302856,0.537904288 L6.03585056,8.49198453 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.2864fd83888228de90fb0e1435f57259.svg";
export { ForwardRef as ReactComponent };